/**
 * AAPI2 Routes
 *
 * The top level object has keys that are types of entities (think:
 * database tables). Under those keys are RESTful instance (key: "one") and collection routes
 * (key: "all").
 *
 * Some routes won't fit in this paradigm so put them in the most logical place. For endpoints that
 * share the same route but use different HTTP verbs, just add the route once.
 */
export default {
  orgAdmins: {
    all: orgId => `/organizations/${orgId}/admins`,
  },
  orgProjects: {
    all: orgId => `/organizations/${orgId}/projects`,
    archive: orgId => `/organizations/${orgId}/projects_/archive`,
    one: (orgId, projectId) => `/organizations/${orgId}/projects/${projectId}`,
    profile: (orgId, projectId) =>
      `/organizations/${orgId}/projects/${projectId}/profile`,
    removeFromOrg: projectId => `/projects/${projectId}/organization`,
    restore: orgId => `/organizations/${orgId}/projects_/restore`,
  },
  orgProjectRoles: {
    all: (orgId, projectId) =>
      `/organizations/${orgId}/projects/${projectId}/roles`,
  },
  orgProjectUsers: {
    all: (orgId, projectId) =>
      `/organizations/${orgId}/projects/${projectId}/users`,
    batch: (orgId, projectId) =>
      `/organizations/${orgId}/projects/${projectId}/users_/batch`,
    delete: (orgId, projectId) =>
      `/organizations/${orgId}/projects/${projectId}/users_/delete`,
  },
  orgUsers: {
    all: orgId => `/organizations/${orgId}/users`,
    batch: orgId => `/organizations/${orgId}/users_/batch`,
    expireSessions: userId => `/user/${userId}/sessions/expire`,
    one: (orgId, userId) => `/organizations/${orgId}/users/${userId}`,
  },
  orgEntitlements: {
    all: orgId => `/organizations/${orgId}/entitlements`,
  },
  orgFeatureFlags: {
    all: orgId => `/organizations/${orgId}/feature_flags`,
  },
  orgUserProjects: {
    all: userId => `/user/${userId}/projects`,
    delete: userId => `/users/${userId}/projects_/delete`,
  },
};
